import Vue from 'vue'
import wx from 'weixin-js-sdk'
import { Toast } from 'vant'

Vue.use(Toast)

Toast.setDefaultOptions({ duration: 3000 });
const utils = {
  toastNone(text) {
    Toast(text)
  },
  toastError(text) {
    Toast.fail(text + '')
  },

  toastSuccess(text) {
    Toast.success(text + '')
  },

  loading() {
    Toast.loading({
      duration: 10000,       // 持续展示 toast
      forbidClick: true, // 禁用背景点击
      message: '加载中...'
    })
  },

  loaded() {
    Toast.clear()
  },

  // 获取地址栏参数
  getUrlParam(url) {
    let vessel = {}
    let param = url.split('?')[1]
    if (!param) {
      return {}
    } else {
      let _param = param.split('&')
      _param.forEach((obj) => {
        vessel[obj.split('=')[0]] = obj.split('=')[1]
      })
    }
    return vessel
  },
  // 判断ios 和 android
  getDeviceOS() {
    let rs = ''
    let ua = window.navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(ua)) {
      rs = 'ios'
    } else if (/android/.test(ua)) {
      rs = 'android'
    }
    return rs
  },
  // 是否APP中打开
  isApp() {
    let ua = window.navigator.userAgent.toLowerCase() // toLowerCase 转换为小写
    if (ua.indexOf('yjwh') !== -1) {
      return true
    } else {
      return false
    }
  },
  // 是否微信中打开
  isWeixin() {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') !== -1) {
      return true
    } else {
      return false
    }
  },
  //是否在支付宝打开
  isZhiFuBai() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('alipay') !== -1) {
      return true; // 是
    } else {
      return false; // 否
    }
  },
  // 是否小程序打开
  isWeChatApplet() {
    // console.log('进入小程序判断')
    return new Promise((resolve) => {
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') === -1) { // 不在微信或小程序中
        return false
      } else {
        wx.miniProgram.getEnv((res) => {
          resolve(res)
        })
      }
    })
  },
  // 微信登录
  wxLogin() {
    let url = window.location.href
    let redirectUrl = encodeURIComponent(`https://weapi.yjwh.shop/user/auth2/redirect?reurl=${url}`)
    let appid = 'wxe147d2d39076d54c'
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
  },
  wxShare(title, desc, imgUrl, url) {
    wx.ready(function () {
      wx.onMenuShareAppMessage({ // 分享朋友
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () { }
      })
      wx.onMenuShareTimeline({ // 分享朋友圈
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function () { }
      })
    })
  }
}

export default utils
